<template>
  <div class="compare">
    <div class="compare__header">
      <button
        class="compare__headerButton button button--secondary button--arrowBack"
        v-on:click="navigateBack"
      >
        {{ $t('compare.back') }}
      </button>
      <router-link
        v-if="vehicles.length > 0"
        :to="'/'"
        class="compare__headerButton button button--primary button--arrow"
        >{{ $t('compare.searchMore') }}</router-link
      >
      <h1 class="compare__title">{{ $t('compare.pageTitle') }}</h1>
    </div>
    <!-- .compare__header -->

    <template v-if="vehicles.length > 0">
      <!-- DESKTOP -->
      <template
        v-if="layoutSize === 'md' || layoutSize === 'lg' || layoutSize === 'xl'"
      >
        <div class="compare__table">
          <div class="compare__table__inner">
            <div class="compare__table__row compare__table__row--header">
              <div
                class="compare__table__cell compare__table__cell--label"
              ></div>
              <div
                class="compare__table__cell"
                v-for="vehicle of vehicles"
                :key="vehicle.id"
              >
                <router-link :to="'/voertuig/' + vehicle.id + '/' + $options.filters.slugify($options.filters.vehicleTitle(vehicle))">
                  <img
                    v-if="vehicle.images.length > 0"
                    class="compare__itemImage"
                    :src="vehicle.images[0]"
                  />
                  <div v-else class="compare__itemImagePlaceholder"></div>
                </router-link>
                <div class="compare__itemTitleWrapper">
                  <h2 class="compare__itemTitle">
                    {{ vehicle.properties.brand }}
                    {{ vehicle.properties.model }}
                  </h2>
                  <button
                    @click="removeVehicle(vehicle)"
                    class="
                      compare__deleteButton
                      button button--secondary button--delete
                    "
                  ></button>
                </div>
                <!-- .compare__itemTitleWrapper -->
              </div>
              <!-- .compare__itemHead -->
            </div>
            <!-- .compare__table__row -->

            <div
              v-for="rowName of tableRows"
              :key="rowName"
              class="compare__table__row"
            >
              <div class="compare__table__cell compare__table__cell--label">
                {{ $t('vehicle.' + rowName) }}
              </div>
              <div
                class="compare__table__cell"
                v-for="vehicle of vehicles"
                :key="vehicle.id"
              >
                <template v-if="rowName === 'type'">
                  {{ vehicle.properties[rowName] | cleanTitle }}
                </template>
                <template v-else-if="rowName === 'price'">
                  {{ vehicle.properties[rowName] | toEUR }}
                </template>
                <template v-else-if="rowName === 'mileage'">
                  {{ vehicle.properties[rowName] | thousandSeparated }} {{ $t('vehicle.mileageUnit') }}
                </template>
                <template v-else-if="rowName === 'enginePower'">
                  {{ vehicle.properties.enginePowerKW }} {{ $t('vehicle.energyPowerUnit') }} ({{
                    vehicle.properties.enginePowerPK
                  }}
                  {{ $t('vehicle.horsePowerUnit') }})
                </template>
                <template v-else>
                  {{ vehicle.properties[rowName] }}
                </template>
              </div>
              <!-- .compare__table__cell -->
            </div>
            <!-- .compare__table__row -->
          </div>
          <!-- .compare__table__inner -->
        </div>
        <!-- .compare__table -->
      </template>

      <!-- MOBILE -->
      <template v-else>
        <div class="compare__table compare__table--mobile">
          <div class="compare__table__inner">
            <div class="compare__table__row">
              <div
                class="compare__table__cell compare__table__cell--label"
              ></div>
              <div class="compare__table__cell"><strong>{{ $t('compare.photo') }}</strong></div>
              <div
                v-for="rowName of tableRows"
                :key="rowName"
                class="compare__table__cell"
              >
                <strong>{{ $t('vehicle.' + rowName) }}</strong>
              </div>
            </div>
            <!-- .compare__table__row -->

            <div
              v-for="vehicle of vehicles"
              :key="vehicle.id"
              class="compare__table__row"
            >
              <div class="compare__table__cell compare__table__cell--label">
                {{ vehicle.properties.brand }} {{ vehicle.properties.model }}
                <button
                  @click="removeVehicle(vehicle)"
                  class="
                    compare__deleteButton
                    button button--secondary button--delete
                  "
                ></button>
              </div>

              <div class="compare__table__cell">
                <img class="compare__itemImage" :src="vehicle.images[0]" />
              </div>

              <div
                class="compare__table__cell"
                v-for="rowName of tableRows"
                :key="rowName"
              >
                <template v-if="rowName === 'type'">
                  {{ vehicle.properties[rowName] | cleanTitle }}
                </template>
                <template v-else-if="rowName === 'price'">
                  {{ vehicle.properties[rowName] | toEUR }}
                </template>
                <template v-else-if="rowName === 'mileage'">
                  {{ vehicle.properties[rowName] | thousandSeparated }} {{ $t('vehicle.mileageUnit') }}
                </template>
                <template v-else-if="rowName === 'enginePower'">
                  {{ vehicle.properties.enginePowerKW }} {{ $t('vehicle.energyPowerUnit') }} ({{
                    vehicle.properties.enginePowerPK
                  }}
                  {{ $t('vehicle.horsePowerUnit') }})
                </template>
                <template v-else>
                  {{ vehicle.properties[rowName] }}
                </template>
              </div>
              <!-- .compare__table__cell -->
            </div>
            <!-- .compare__table__row -->
          </div>
          <!-- .compare__table__inner -->
        </div>
        <!-- .compare__table -->
      </template>
    </template>
    <template v-else>
      <div class="compare__table noVehicles">
        <h2 class="noVehicles__title">{{ $t('compare.emptyState.title') }}</h2>
        <p class="noVehicles__text">
          {{ $t('compare.emptyState.desc') }}
        </p>
        <br />
        <router-link
          class="button button--secondary button--arrow noVehicles__resetButton"
          :to="'/'"
          >{{ $t('compare.emptyState.button') }}</router-link
        >
      </div>
    </template>
  </div>
</template>

<script>

export default {
  created () {
    document.title = 'Occasions vergelijken'
    this.$store.commit(
      'compare/removeDeletedVehicles',
      this.$store.getters['vehicles/all']
    )
  },
  data () {
    return {
      loading: false,
      tableRows: [
        'type',
        'price',
        'year',
        'mileage',
        'fuelType',
        'enginePower',
        'transmission'
      ]
    }
  },
  computed: {
    layoutSize: function () {
      return this.$store.state.layout.size
    },
    vehicles: function () {
      const vehiclesToCompare = this.$store.getters['compare/vehicles']
      const allVehicles = this.$store.getters['vehicles/all']
      return this.$options.filters.findVehicles(vehiclesToCompare, allVehicles)
    }
  },
  methods: {
    removeVehicle (vehicle) {
      this.$store.commit('compare/removeVehicle', vehicle)
    },
    navigateBack () {
      this.$router.go(-1)
    }
  }
}
</script>
